export default __webpack_public_path__ + "static/media/Match-end.9c77f7a0.mp3";